<template>
  <div class="EditTodoTemplateItem">
    <div class="boon-form-container" :class="{ archived: todoTemplateItem.archived }">
      <span v-if="todoTemplateItem.new">{{ $t('Add New') }}</span>
      <span v-if="!todoTemplateItem.new" class="glyphicon-move" aria-hidden="true">&#8597;</span>

      <DropDown
        :style="{ color: todoTemplateItem.colour }"
        v-if="!todoTemplateItem.new"
        icon="droplet-half"
        :title="$t('Colour')"
      >
        <li v-for="colour in colours" :key="colour.hexcode">
          <span @click="updateProperty('colour', colour.hexcode)" :style="{ color: colour.hexcode }">
            <b-icon
              v-if="colour.hexcode === todoTemplate.colour"
              icon="droplet-fill"
              :style="{ color: colour.hexcode }"
            />
            <b-icon v-else icon="droplet-half" :title="colour.title" :style="{ color: colour.colour }" />
          </span>
        </li>
      </DropDown>
      <inputField
        id="title"
        ref="title"
        class="half"
        :label="$t('Title')"
        :value="todoTemplateItem.title"
        :readonly="todoTemplateItem.archived"
        @input="updateProperty('title', $event)"
      />

      <iconToggle
        v-if="!todoTemplateItem.new"
        :value="todoTemplateItem.archived"
        @input="updateProperty('archived', $event)"
        iconOff="static/icon/H2BOON-list-missing.png"
        iconOn="static/icon/H2BOON-list-plus.png"
        class="right"
        :tab="false"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EditTodoTemplateItem from './EditTodoTemplateItem';
import inputField from '@/components/form/inputField';
import DropDown from '@/components/dropdown/DropDown';
import iconToggle from '@/components/iconToggle/iconToggle';

export default {
  name: 'EditTodoTemplateItem',
  props: {
    todoTemplate: Object,
    todoTemplateItem: {
      default: () => {
        return { new: true, title: '' };
      },
    },
    index: Number,
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(['saveTodoTemplateItemProperties']),
    updateProperty: function (property, newValue) {
      if (this.todoTemplateItem[property] !== newValue) {
        var newTodoTemplateItemProperties = {};
        newTodoTemplateItemProperties[property] = newValue;
        this.saveTodoTemplateItemProperties({
          updateTodoTemplate: this.todoTemplate,
          index: this.index,
          newTodoTemplateItemProperties: newTodoTemplateItemProperties,
        });
      }
    },
    focus: function () {
      this.$refs['title'].focus();
    },
  },
  computed: {
    ...mapGetters(['colours', 'hasSimplePermissions']),
  },
  components: {
    EditTodoTemplateItem,
    DropDown,
    iconToggle,
    inputField,
  },
};
</script>

<style scoped>
img.icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}
.boon-form-container {
  display: flex;
  flex-direction: row;
  padding: 20px 0;
  margin: 0 30px;
}

.glyphicon-move {
  color: #ffffff;
  width: inherit;
  margin: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/project/EditTodoTemplateItem.vue